import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CommonTabs = ({ value, onChange, tabs, content }) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={value}
                onChange={onChange}
                aria-label="common tabs"
                variant={'scrollable'}
                scrollButtons={false}
                sx={{
                    '& .MuiTab-root': {
                        fontFamily: 'Poppins',
                        fontSize: '16px',
                        textTransform: 'none',
                    },
                    '& .MuiTabs-indicator': {
                        background: `linear-gradient(to right, #F5D01C, #826320)`,
                    },
                    '& .MuiTab-root.Mui-selected': {
                        fontWeight: 500,
                        background: `linear-gradient(to right, #F5D01C, #826320)`,
                        WebkitBackgroundClip: 'text',
                        backgroundClip: 'text',
                        color: 'transparent',
                    },
                }}>
                {tabs.map((tab, index) => (
                    <Tab key={index} label={t(tab.translationKey)} />
                ))}
            </Tabs>
            <Box sx={{ p: 2 }}>
                {content[value]}
            </Box>
        </Box>
    );
};

export default CommonTabs;
